<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
        <div class="form-wrapper">
          <BaseElDialog
            title="Reemplazar Certificado"
            :visible.sync="showModal"
            @open="handleOpenModalDialog('container-replace-cert-changes')"
            @closed="releaseFocusDialog"
            width="40%"
            custom-class="min-width-dialog"
            center
          :show-close="false">
            <span :key="t"  v-for="t in processMessage" class="text-center w-full inline-block word-break-n">{{ t }}</span>
            <template slot="footer" >
              <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-replace-cert-changes">
                <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
                <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="save" :loading="loading" />
              </div>
            </template>
          </BaseElDialog>
          <BaseElDialog
            title="Comprobación de datos"
            :visible.sync="showModalCheckData"
            @open="handleOpenModalDialog('container-check-data-changes')"
            @closed="releaseFocusDialog"
            width="40%"
            custom-class="min-width-dialog"
            center
          :show-close="false">
            <span :key="t"  v-for="t in processMessageCheckData" class=" w-full inline-block word-break-n">{{ t }}</span>
            <template slot="footer" >
              <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-check-data-changes">
                <base-button class="w-full" @click="showModalCheckData = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
                <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="subirCertificado" :loading="loading" />
              </div>
            </template>
          </BaseElDialog>
          <BaseElDialog
            title="Borrar Certificado antiguo"
            :visible.sync="showModalDelete"
            @open="handleOpenModalDialog('container-delete-cert-changes')"
            @closed="releaseFocusDialog"
            width="40%"
            custom-class="min-width-dialog"
            @close="hideAndGoBack"
            center
            :show-close="false">
            <span class="text-center w-full inline-block word-break-n">{{ processMessageDelete }}</span>
            <template slot="footer" >
              <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-delete-cert-changes">
                <base-button class="w-full" @click="showModalDelete = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
                <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')"  @click="deleteCertificate" :loading="loading" />
              </div>
            </template>
          </BaseElDialog>
          <el-form
            :model="form"
            :rules="rules"
            ref="ruleForm"
            class="flex flex-row w-full"
          >
          <div class="flex-1">
          <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4">{{$t('certificates.group_old_cert')}}</h2>
             <div class="mb-6">
              <div  class="lg:mb-2">
                <base-ro-input :label="$t('certificates.name')" :data="form.oldCommonName"/>
              </div>
              <div class="lg:mb-2">
                    <base-ro-input :label="$t('certificates.serial')" :data="form.oldHashPFX"/>
                  </div>
              <!-- <div class="lg:mb-2">
                <div class="mandatory">
                  <base-ro-input :label="$t('certificates.expires_at')" :data="form.CertFechaCaducidad"/>
                </div>
              </div> -->
            </div>

          <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4">{{$t('certificates.group_new_cert')}}</h2>
            <div class="lg:mb-2">
              <AccessibleElSelect
                v-model="form.type"
                prop="type"
                :options="tiposCertificadoForAccessibleSelect"
                :withFormItem="true"
                id-prefix="replacecertificate"
                @change="onChangeType"
              >
                <template slot="label">{{$t('certificates.type_extend')}}</template>
              </AccessibleElSelect>
            </div>

            <div v-if="form.type === 'pfx'" >
               <div class="lg:mb-2">
                    <span id="replacecert-password-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('certificates.password')}}</span>
                    <el-form-item prop="password">
                      <el-input
                        aria-labelledby="replacecert-password-label"
                        show-password
                        v-model="form.password"
                        maxlength='255'
                        >
                        <template v-if="form.password.value" slot="suffix">
                          <base-clear-input-button
                            aria-label="Limpiar campo de contraseña"
                            @clear="form.password.value = ''"
                          />
                        </template>
                      </el-input>
                    </el-form-item>
                <div class="flex -mx-2 flex-col lg:flex-row">
                  <div class="px-2  mb-2 lg:mb-0">
                    <base-obligatory-icon/>
                    <el-form-item prop="file" ref="uploadpfxref">
                      <Upload
                        role="button"
                        ref="upload"
                        accept=".pfx,.p12"
                        id="pfxselector"
                        class="bg-white dark:bg-darkblue-900 "
                        :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']"
                        drag
                        action="#"
                        :show-file-list="false"
                        :multiple="false"
                        :auto-upload=false
                        :on-remove="handleRemove"
                        :on-change="handleChange">
                        <i class="el-icon-upload"></i>
                        <p v-if="file.name" class="el-upload__text"><em>{{file.name}}</em></p>
                        <div v-else class="el-upload__text">Suelta tu archivo aquí o <em>haz clic para cargar</em></div>
                      </Upload>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </div>

            <div class="lg:mb-2" v-if="form.type === 'srl'">
              <span id="replacecert-serial-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('certificates.serial')}}</span>
              <el-form-item prop="HashPFX">
                <el-input
                  aria-labelledby="replacecert-serial-label"
                  v-model="form.HashPFX"
                  maxlength='100'
                  >
                  <template v-if="form.HashPFX" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo de contraseña"
                      @clear="form.HashPFX = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
              <span id="replacecert-name-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('certificates.name')}}</span>
              <el-form-item prop="CommonName">
                <el-input
                  aria-labelledby="replacecert-name-label"
                  v-model="form.CommonName"
                  maxlength='50'
                  >
                  <template v-if="form.CommonName" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo de nombre"
                      @clear="form.CommonName = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>

            <div class="lg:mb-2" v-if="form.type === 'usr'">
              <span id="replacecert-user-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('certificates.user')}}</span>
              <el-form-item prop="user">
                <el-input
                  aria-labelledby="replacecert-user-label"
                  v-model="form.user"
                  maxlength='50'
                  >
                  <template v-if="form.user" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo de usuario"
                      @clear="form.user = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
              <span id="replacecert-pass-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('certificates.pass')}}</span>
              <el-form-item prop="pass">
                <el-input
                  aria-labelledby="replacecert-pass-label"
                  v-model="form.pass"
                  maxlength='50'
                  >
                  <template v-if="form.pass" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo de contraseña"
                      @clear="form.pass = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>

            <div class="lg:mb-2" v-if="(form.type === 'srl' || form.type === 'usr')">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('certificates.expires_at')}}
                <el-form-item prop="CertFechaCaducidad">
                  <el-date-picker
                    class="bg-white dark:bg-darkblue-900"
                    v-model="form.CertFechaCaducidad"
                    type="date"
                    format="dd-MM-yyyy"
                    :picker-options="dateRangeOptions"
                    placeholder="dd-mm-aaaa"
                    ref="datePickerFechaCaducidad"
                    @blur="onBlurDatePickerMixin('.datePickerFechaCaducidad-popover')"
                    @focus="onFocusDatePickerMixin('.datePickerFechaCaducidad-popover')"
                    @keydown.native="captureKeyNotChrome"
                    popper-class="datePickerFechaCaducidad-popover"
                    >
                  </el-date-picker>
                </el-form-item>
              </label>
            </div>
          </div>
          </el-form>
        </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="$t('app.cancel')" icon="cross" @click="goBack" :loading="isGeneralLoading"/>
          <base-button-responsive mode="primary" :text="$t('app.save')" icon="save" @click="submitForm('ruleForm')" :loading="isGeneralLoading" :disabled="isGeneralLoading"/>
        </template>
      </base-footer>
    </template>
  </detail-layout>
</template>

<script>
import { TIPOS_CERT } from '@/config/tipos-cert'
import DetailLayout from '@/components/layout/DetailLayout.vue'
import { getCertificate } from '@/services/certificates/getCertificate'
import { getPfxData } from '@/services/certificates/getPfxData'

import { Upload } from 'element-ui'
import BaseElDialog from '@/components/base/BaseElDialog.vue'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

import { replaceCertificate } from '@/services/certificates/replaceCertificate'

import moment from 'moment'
import { i18n } from '@/i18n'
import { deleteCertificate } from '@/services/certificates/deleteCertificate'

export default {
  /* eslint-disable camelcase */
  name: 'template-detail',
  components: {
    Upload,
    BaseElDialog,
    DetailLayout,
    AccessibleElSelect
    // DetailLayoutFullWidth
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      loading: false,
      searchView: false,
      activeName: 'es',
      header: {
        title: ' REEMPLAZAMIENTO DE CERTIFICADO',
        icon: 'certificates',
        breadcrumb: {},
        nav: [],
        url: 'certificates'
      },
      file: {
        name: '',
        b64: ''
      },
      selectedCifs: [],
      showModal: false,
      showModalCheckData: false,
      checkDataSerialNumber: '',
      checkDataCommonName: '',
      checkDataExpirationDate: '',
      tiposCertificado: TIPOS_CERT,
      form: {
        oldCommonName: '',
        oldHashPFX: '',

        type: 'pfx',
        CommonName: '',
        HashPFX: '',
        CertFechaCaducidad: '',
        file: '',
        password: '',
        clienteId: null,
        user: '',
        pass: '',
        id: 0
      },
      showModalDelete: false,
      processMessageDelete: '¿Desea eliminar el certificado que ha sido sustituido?',
      rules: {
        clienteId: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        password: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        HashPFX: [
          { validator: this.isSerialNumberValid, trigger: 'blur' }
        ],
        CommonName: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        user: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        pass: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        type: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        CertFechaCaducidad: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        file: [
          {
            message: this.$i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.file.name) {
                this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
              } else {
                callback()
              }
            }
          },
          {
            message: this.$i18n.t('validation.not_pfx'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.file.name || 
                this.file.name.length < 5 || 
                !['.PFX', '.P12'].includes(this.file.name.substr(this.file.name.length - 4).toUpperCase())) {
                this.doAriaLiveAndReturnCallback(i18n.t('validation.not_pdf'), callback)
              } else {
                callback()
              }
            }
          }
        ]
      }
    }
  },
  computed: {
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    idEmpresa: function () {
      return this.$route.params.idEmpresa
    },
    serial: function () {
      return this.$route.params.serial
    },
    tipoCertificado: function () {
      return this.$route.params.tipo
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    processMessage: function () {
      const message = []
      let nombreCert = ''
      if (this.form.type === 'pfx') nombreCert = this.file.name
      else if (this.form.type === 'srl') nombreCert = 'con serial "' + this.form.HashPFX + '"'
      else if (this.form.type === 'usr') nombreCert = 'con usuario "' + this.form.user + '"'
      const nombreCertOld = 'con serial "' + this.serial + '"'
      message.push('¿Quieres reemplazar el certificado ' + nombreCertOld + ' por el nuevo certificado ' + nombreCert + '?')

      return message
    },
    processMessageCheckData: function () {
      const message = []
      const nombreCertOld = 'con serial "' + this.serial + '"'
      message.push('¿Quieres reemplazar el certificado ' + nombreCertOld + ' por el que contiene los siguientes datos?')
      message.push('')
      message.push('Número de serie: ' + this.checkDataSerialNumber)
      message.push('Nombre: ' + this.checkDataCommonName)
      message.push('Fecha de caducidad: ' + moment(this.checkDataExpirationDate).format('DD-MM-yyyy HH:mm'))

      return message
    },
    tiposCertificadoForAccessibleSelect () {
      return this.tiposCertificado.map(tipo => ({
        id: tipo.id,
        name: tipo.name,
        value: tipo.id,
        disabled: tipo.disabled === true
      }))
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    'form.type': function (value, oldValue) {
      this.doFeedback(this.$i18n.t('app.alert_form_changes'), 'info')
    }
  },
  created: async function () {
    const idEmpresa = this.idEmpresa
    const serial = this.serial
    const tipoCert = this.tipoCertificado
    const breadcrumbs = []
    await this.downloadData(idEmpresa, serial, tipoCert)
    if (this.$route.params.noticeType !== undefined && this.$route.params.noticeType !== null && this.$route.params.noticeType !== '') {
      if (this.$route.params.noticeType === 'certificadoscaducar') {
        this.header.url = 'notices/certificadoscaducar'
        breadcrumbs.push({ path: 'notices/certificadoscaducar', name: this.$i18n.t('app.noticesCertsCaduc') })
      } else {
        this.header.url = 'notices/certificadoscaducados'
        breadcrumbs.push({ path: 'notices/certificadoscaducados', name: this.$i18n.t('app.noticesCertsCaducados') })
      }
    } else {
      breadcrumbs.push({ path: 'certificates', name: this.$i18n.t('app.certificates') })
    }
    breadcrumbs.push({ path: '', name: this.form.oldCommonName })
    this.$store.commit('app/setheaderBreadCrumb', this.form.oldCommonName)
    
    this.header.breadcrumb = breadcrumbs
  },
  mounted () {
    this.resetControlFormChanges()
  },
  methods: {
    handleOpenModalDialog (refName) {
      this.handleOpenModalDialogMixin(refName)
    },
    releaseFocusDialog () {
      this.releaseFocusDialogMixin()
    },
    isSerialNumberValid: function (rule, value, callback) {
      const re = /["<>|:*?\\/]/
      if (!value) {
        return this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
      } else if (re.test(value)) {
        return this.doAriaLiveAndReturnCallback(i18n.t('validation.codigo_ext.chars'), callback)
      } else if (value.length < 5) {
        return this.doAriaLiveAndReturnCallback(i18n.t('validation.length_min') + '5 caracteres', callback)
      } else {
        callback()
      }
    },
    onChangeType: function (value) {
      // console.log('onChangeType', value)
    },
    watchFormHandler: function ({ CertFechaCaducidad }) {
      if (CertFechaCaducidad !== undefined && moment(CertFechaCaducidad).isValid()) {
        this.form.CertFechaCaducidad = moment(CertFechaCaducidad).format('YYYY-MM-DD')
      } else {
        this.form.CertFechaCaducidad = ''
      }
      this.$store.commit('app/setFormChanges', true)
    },
    submitForm: function (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.form.type === 'pfx') this.uploadPFX()
          else this.showModal = true
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
          return false
        }
      })
    },
    goBack: function () {
      this.$router.push({ name: 'certificates' })
    },
    hideAndGoBack () {
      this.showModalDelete = false
      this.goBack()
    },
    downloadData: async function (idEmpresa, serial, tipoCertificado) {
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idEmpresa,
          serial,
          tipoCertificado
        }
        const data = await getCertificate(params)
        if (data.blnError === true) {
          this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
        } else {
          this.setCertificate(data.Certificado)
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    setCertificate: function (certificate) {
      this.form.oldHashPFX = certificate.HashPFX
      this.form.oldCommonName = certificate.CommonName
      // this.form.oldtype = certificate.TipoCertificado
      // this.form.oldCertFechaCaducidad = moment(certificate.CertFechaCaducidad).format('DD-MM-yyyy HH:mm')
      // this.form.oldclienteId = certificate.idEmpresa
      this.resetControlFormChanges()
    },
    handleChange: function (file) {
      this.$refs.uploadpfxref.clearValidate()
      this.file.name = file.name
      this.getBase64(file.raw).then(res => {
        const b64 = res.split(',')
        this.file.b64 = b64[1]
      })
    },
    handleRemove: function () {
      this.file.name = null
      this.file.b64 = null
    },
    save: async function () {
      try {
        this.loading = true
        await this.uploadPFX()
        this.showModal = false
      } catch (error) {
        this.doFeedback()
      } finally {
        this.loading = false
      }
    },
    getIDOldCert () {
      const data = {
        SerialNumber: this.serial,
        TipoCertificado: this.tipoCertificado,
        idEmpresa: this.idEmpresa,
      }
      return data
    },
    deleteCertificate: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const data = this.getIDOldCert()
        const payload = []
        payload.push(data)
        const response = await deleteCertificate(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.showModalDelete = false
      }
    },
    uploadPFX: async function () {
      if (this.form.type === 'pfx') {
        const payload = {
          base64: this.file.b64,
          pwd: this.form.password,
          idEmpresa: 0,
        }
        const responseGetData = await getPfxData(payload)
        if (responseGetData.blnError === false) {
          this.checkDataSerialNumber = responseGetData.datosCertificado.SerialNumber
          this.checkDataCommonName = responseGetData.datosCertificado.CommonName 
          this.checkDataExpirationDate = responseGetData.datosCertificado.ExpirationDate
          this.showModalCheckData = true
          this.resetControlFormChanges()
        } else {
          this.doFeedback(responseGetData.msgError + ' [Código de error: ' + responseGetData.codError + ']')
        }
      } else {
        this.subirCertificado()
      }
    },
    subirCertificado: async function () {
      this.showModalCheckData = false
      this.$store.commit('app/setLoading', true)
      const data = this.getIDOldCert()
      if (this.form.type === 'pfx') {
        data.nuevoCertificado = {
          base64: this.file.b64,
          pwd: this.form.password,
          TipoCertificado: 'pfx',
          nombreFichero: this.file.name,
        }
      } else if (this.form.type === 'srl') {
        data.nuevoCertificado = {
          SerialNumber: this.form.HashPFX,
          CommonName: this.form.CommonName,
          FechaExpiracion: this.form.CertFechaCaducidad,
          TipoCertificado: 'srl',
        }
      } else if (this.form.type === 'usr') {
        data.nuevoCertificado = {
          Usuario: this.form.user,
          Password: this.form.pass,
          FechaExpiracion: this.form.CertFechaCaducidad,
          TipoCertificado: 'usr',
        }
      }
      const response = await replaceCertificate(data)

      if (response.blnError === false) {
        this.doFeedback('Certificado sustituido con éxito', 'success')
        this.showModalDelete = true
        if (this.form.type === 'pfx') this.$refs.upload.clearFiles()
        this.file = {
          name: null,
          b64: null
        }
        this.resetForm()
        this.form.CommonName = ''
        this.form.HashPFX = ''
        this.form.CertFechaCaducidad = ''
        this.form.file = ''
        this.form.password = ''
        this.form.clienteId = null
        this.form.user = ''
        this.form.pass = ''
        this.form.id = 0
        this.$store.commit('app/setLoading', false)
        this.resetControlFormChanges()
      } else {
        this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
      }
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    selectionChange: function (selectedData) {
      this.selectedCifs = selectedData
    },
    handleSelect: function (item) {
      this.selectedCifs = []
      this.selectedCifs.push(item)
    }
  }

}
</script>

<style scoped>

.el-upload-dragger {
    background-color: #fff;
    border: 1px
    dashed #d9d9d9;
    border-radius: 6px;
    box-sizing: border-box;
    width: 360px;
    height: 180px;
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.tip {
  grid-column: 1 / -1;
}
.pic>img {
  max-width: 100%;
}

.file-selected {
  color: rgb(90, 90, 90);
  text-transform: uppercase;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

 .el-loading-parent--relative {
    position: relative !important; }

  .el-loading-parent--hidden {
    overflow: hidden !important; }

    div.el-loading-mask {
        background-color: rgba(6,13,46,.8);
    }

  .el-loading-mask {
    position: absolute;
    z-index: 2000;
    background-color: rgba(255, 255, 255, 0.9);
    margin: 0;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    -webkit-transition: opacity 0.3s;
    transition: opacity 0.3s; }
    .el-loading-mask.is-fullscreen {
      position: fixed; }
      .el-loading-mask.is-fullscreen .el-loading-spinner {
        margin-top: -25px; }
        .el-loading-mask.is-fullscreen .el-loading-spinner .circular {
          height: 50px;
          width: 50px; }
    div.el-loading-mask .el-loading-spinner {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
body.el-loading-parent--relative {
    position: inherit !important;
}
  .el-loading-spinner {
    top: 50%;
    margin-top: -21px;
    width: 100%;
    text-align: center;
    position: absolute; }
    .el-loading-spinner .el-loading-text {
      color: #00BBFF;
      margin: 3px 0;
      font-size: 14px; }
    .el-loading-spinner .circular {
      height: 42px;
      width: 42px;
      -webkit-animation: loading-rotate 2s linear infinite;
      animation: loading-rotate 2s linear infinite; }
    .el-loading-spinner .path {
      -webkit-animation: loading-dash 1.5s ease-in-out infinite;
      animation: loading-dash 1.5s ease-in-out infinite;
      stroke-dasharray: 90, 150;
      stroke-dashoffset: 0;
      stroke-width: 2;
      stroke: #00BBFF;
      stroke-linecap: round; }
    .el-loading-spinner i {
      color: #00BBFF; }

  .el-loading-fade-enter,
  .el-loading-fade-leave-active {
    opacity: 0; }
</style>

<style lang="sass" scoped>
</style>
